export const ACADEMIC_YEAR = '2026-27'
export const ACADEMIC_YEAR_FULL = '2026-2027'
export const NOTIFICATION_DATE = '11th September, 2026'
export const CURRENT_YEAR = '2026'
